import React from 'react';
import { getMaterialUIComponent, getMUIComponent, InitializeMUIComponent, deleteComponentFromCache} from './materialUIComponents';
import { httpRequestSync, castToType, parseFunction, prepareCoreDefinitionSchemaFromCoreMetaData, translateRelativePaths,  translateFunction, translateFunctions, translatePropsToUiComponents, coreJsonMerge, map, clone, concat, httpRequest, mapObject, coreTokenExists, parseSchema, executeSchema, parseFunctions, coreSetToken, coreSelectToken, isFunction, coreJsonIsEmpty } from './coreFunctions2';
import { HdrWeakOutlined, TurnRightSharp } from '@mui/icons-material';
import {ClientJS} from 'clientjs';

class CoreComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            initialized: false,
            loadingSchema: false,
            value: null,
            loadSchema: props.urlSchema !== undefined,
            hovering: false,
            modalOpen: false,
            snackbar: { 
                open: false,
                duration: 6000,
                severity: "success",
                message: "",
                width: null,
                vertical: "bottom",
                horizontal: "center"
            },
            initializingComponent: {},
            initializingUiSchema: {},
            rendering: false,
            rendered: false,
            renderTimeStamp: null,
            reason: "none",
            behaviour: "none",
            cursorPosition: -1,
            containerWidth: 0,
            containerHeight: 0,
            isDesktop: true,
            decoration: {
                offsetWidth: 0,
                offsetHeight: 0,
                width: 0,
                height: 0,
                currentBreakpoint: ""
            },
            dataAsDataSource: false,
            onChangeDebounce: 500
        };
        
        
        this.onChangeTimeout = null;
        this.notifyParent = this.notifyParent.bind(this);
        this.childNotification = this.childNotification.bind(this);
        this.loadSchema = this.loadSchema.bind(this);
        this.core_InitializeComponent = this.core_InitializeComponent.bind(this);
        this.renderUiSchema = this.renderUiSchema.bind(this);
        this.default_onChange = this.default_onChange.bind(this);
        this.default_onBlur = this.default_onBlur.bind(this);
        this.default_onDoubleClick = this.default_onDoubleClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onDoubleClick = this.onDoubleClick.bind(this);
        this.onContextMenu = this.onContextMenu.bind(this);
        this.updateContainerSize = this.updateContainerSize.bind(this);

        this.getOption = this.getOption.bind(this);
        this.setOption = this.setOption.bind(this);
        //--- General functions
        this.httpRequestSync = this.httpRequestSync.bind(this);
        this.prepareSchemaFromCoreMetaData = this.prepareSchemaFromCoreMetaData.bind(this);
        this.mergeWithProps = this.mergeWithProps.bind(this);

        // console.log("entro al constructor");
        //----------
        this.coreDefinition = {
            "jsonSchema": {
                "options": {
                    "decoration": {
                        "useRelativeBreakpoint": false,
                            "breakpoints": {
                                "xs": "0px",
                                "sm": "600px",
                                "md": "900px",
                                "lg": "1200px",
                                "xl": "1536px"
                            },
                        "layoutBreakpoints": {
                            "default": "web",
                            "xs": "mobile"
                        }
                    }
                }            
            },
            "uiSchema": {
                "layout": {}
            },
            "components": {}
        };

        // this.rendered = {
        //     "components": {},
        //     "uiSchema": {}
        // };

        // if (coreTokenExists(this.props, "urlSchema.url") && this.props.urlSchema.url !== ""){
        //     this.loadSchema();
        // }else{            
        //     this.initializeComponent(true);
        // }

        this.Content = <></>;

        this.previousProps = {};
        this.myRef = React.createRef();

        // Crear una instancia de ClientJS
        this.client = new ClientJS();

    }

    
    prepareSchemaFromCoreMetaData(coreMetaData, propsCustomization){
        return prepareCoreDefinitionSchemaFromCoreMetaData(coreMetaData, propsCustomization);
    }

    loadSchema(){
        if (this.state.loadingSchema){
            return;
        }

        if (coreJsonIsEmpty(this.props.urlSchema)){
            
            this.setState({
                loadSchema: false,
                loadingSchema: false
            });
            return;
        }

        let requestSchema = this.props.urlSchema;
          let _self = this;          
          let _callback = function (result){

            var schema = JSON.parse(result.data.jsonData);
            if (result.data.javascriptData !== undefined && result.data.javascriptData !== ""){
              var actionFn = eval(result.data.javascriptData);
              schema.props.jsonSchema.options.actions = {...schema.props.jsonSchema.options.actions, ...actionFn()};
            }

            if (schema.props.jsonSchema.data === undefined){
              schema.props.jsonSchema.data = {};
            }

            if (_self.props.urlSchema.props){
                schema.props = coreJsonMerge(schema.props, _self.props.urlSchema.props);
            }

            if (!coreTokenExists(schema.props.jsonSchema.options,"id") && coreTokenExists(schema, "id")){
                coreSetToken(schema,"props.jsonSchema.options.id", schema.id);
            }
            delete schema.id;

            _self.coreDefinition = schema.props;
            // for(var _item in schema.props.jsonSchema){
            //     _self.props.jsonSchema[_item] = schema.props.jsonSchema[_item];
            // }
            // for(var _item in schema.props.uiSchema){
            //     _self.props.uiSchema[_item] = schema.props.uiSchema[_item];
            // }
            // for(var _item in schema.props.components){
            //     _self.props.components[_item] = schema.props.components[_item];
            // }

            _self.state.loadSchema = false;
            _self.state.loadingSchema = false;
            _self.state.loading = false;

            _self.core_InitializeComponent(true);
        }

        this.setState({
            loadingSchema: true,
            loading: true
        });
        console.log("Hago el request del esquema: " + requestSchema.url);
        httpRequest(null, requestSchema, _callback);
    }

    mergeWithProps(props){
        let _merged = false;
        let _previousState = clone(this.state);

        if (JSON.stringify(props) != JSON.stringify(this.previousProps)){
            if (coreTokenExists(props, "jsonSchema")){
                if (coreTokenExists(props, "jsonSchema.options")){
                    if (coreTokenExists(props, "jsonSchema.options.dataSource")){
                        //El dataSource como es un array.. no puedo hacer el merge, lo tengo q pasar por arriba.
                        this.coreDefinition.jsonSchema.options.dataSource = [];
                    }
                }

                this.coreDefinition.jsonSchema = coreJsonMerge(this.coreDefinition.jsonSchema, props.jsonSchema);
                _merged = true;
            }
            if (coreTokenExists(props, "uiSchema")){
                this.coreDefinition.uiSchema = coreJsonMerge(this.coreDefinition.uiSchema, props.uiSchema);
                _merged = true;
            }
            if (coreTokenExists(props, "components")){
                this.coreDefinition.components = coreJsonMerge(this.coreDefinition.components, props.components);
                _merged = true;
            }
            
            if (coreTokenExists(props, "jsonSchema.data") && (typeof props.jsonSchema.data === 'object') && props.jsonSchema.data !== null && Object.keys(props.jsonSchema.data).length > 0){
                let _data = {};
                if (coreTokenExists(props, "jsonSchema.options.initialState.mode") && props.jsonSchema.options.initialState.mode  === "INS"){
                    _data = coreJsonMerge(this.coreDefinition.jsonSchema.data, props.jsonSchema.data);
                    //this.setData(this, null, coreJsonMerge(this.coreDefinition.jsonSchema.data, props.jsonSchema.data), false);
                }else{
                    _data = props.jsonSchema.data;
                    //this.setData(this, null, props.jsonSchema.data, false);
                }
                _data = translateRelativePaths(_data, this, null);
                this.setData(this, null, _data, false);
                _merged = true;
            }else{
                if ((coreTokenExists(props, "jsonSchema.options.initialState.mode") && props.jsonSchema.options.initialState.mode  === "INS")
                    || (!coreTokenExists(props, "jsonSchema.options.initialState.mode") && coreTokenExists(this.coreDefinition, "jsonSchema.data"))){
                    this.setData(this, null, translateRelativePaths(this.coreDefinition.jsonSchema.data, this, null), false);
                    //this.setData(this, null, this.coreDefinition.jsonSchema.data, false);
                    _merged = true;
                }
            }
            
            if ((coreTokenExists(this.previousProps, "jsonSchema.options.initialState") && (JSON.stringify(this.previousProps.jsonSchema.options.initialState) !== JSON.stringify(props.jsonSchema.options.initialState)))
                || (!coreTokenExists(this.previousProps, "jsonSchema.options.initialState") && coreTokenExists(props, "jsonSchema.options.initialState"))
                ){
                //Reseteo los estados...
                let newState = coreJsonMerge(this.state, props.jsonSchema.options.initialState);
                //Excepciones
                if (coreTokenExists(props.jsonSchema.options.initialState, "filters")){
                    newState.filters = translateRelativePaths(props.jsonSchema.options.initialState.filters, this, null);
                    //newState.filters = props.jsonSchema.options.initialState.filters;
                }
                //-----------

                if (this.hasAction("stateSettedFromProps")){
                    this.setState(newState, () => {
                        this.executeAction("stateSettedFromProps", _previousState, props.jsonSchema.options.initialState);
                    });
                }else{
                    newState.reason = "merged_" + (new Date()).toISOString();
                    this.setState(newState);
                }
                console.log("Reseteo el estado porque no coincinde con el original." + this.coreDefinition.jsonSchema.options.id);
            }else{
                if (_merged){
                    if (this.state.initialized){
                        if (this.hasAction("propsUpdated")){
                            let _callbackState = this.propsUpdated ?? this.coreDefinition.jsonSchema.options.actions.propsUpdated;
                            this.executeAction("propsUpdated", this.previousProps, props);
                        }else{
                            this.setState({reason: "merged_" + (new Date()).toISOString()});
                        }
                    }    
                }
            }

            this.previousProps = clone(props);
        }
    }

    async core_InitializeComponent(_setState){
        // console.log("entro a inicializar: " + coreSelectToken(this.coreDefinition, "jsonSchema.options.id") + " props: " + coreSelectToken(this.props, "jsonSchema.options.id") );
        
        //Primero cargo los actions, porque si merge llama a statesettedfromprops, tienen que estar definidas las acciones xa q no falle.
        if (coreTokenExists(this.coreDefinition, "jsonSchema.options.actions")){
            let _actions = this.coreDefinition.jsonSchema.options.actions;
            if (coreTokenExists(this.props, "jsonSchema.options.actions")){
                _actions = coreJsonMerge(this.coreDefinition.jsonSchema.options.actions, this.props.jsonSchema.options.actions);
            }
            for(var action in _actions){
                let _action = await parseFunction(_actions[action], this);
                if (typeof _action === "function"){
                    this[action] = _action.bind(this);
                }
            }
        }
        //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        
        this.mergeWithProps(this.props);
        let newState = this.state;

        try{
            newState.isDesktop = !(window.clientInformation.userAgentData.mobile);
        }catch(ex){
            console.error("no pude ver la propiedad  window.clientInformation.userAgentData.mobile");
            newState.isDesktop = true;
        }

        newState.decoration.currentBreakpoint = this.getCurrentBreakpoint();

        //lo actualizo después del merge
        let jsonSchema = this.coreDefinition.jsonSchema;

        if (this.coreDefinition.jsonSchema.options.initialState){
            let _initalState = clone(this.coreDefinition.jsonSchema.options.initialState);
            if (_initalState.data !== undefined){
                _initalState.data = translateRelativePaths(_initalState.data, this, null);
            }
            newState = coreJsonMerge(newState, _initalState);
        }

        if (coreTokenExists(jsonSchema,"options.actions.onChange")){
            if (typeof jsonSchema.options.actions.onChange === "function"){
                this.onChange = jsonSchema.options.actions.onChange.bind(this);
            }else{
                if (typeof jsonSchema.options.actions.onChange === "object"){
                    let _self = this;
                    this.onChange = (event) => {
                        executeSchema(_self, jsonSchema.options.actions.onChange, event);
                    }
                    this.onChange = this.onChange.bind(this);
                }
            }
        }else{
            this.onChange = this.default_onChange.bind(this);
        }

        if (coreTokenExists(jsonSchema,"options.actions.onBlur")){
            if (typeof jsonSchema.options.actions.onBlur === "function"){
                this.onBlur = jsonSchema.options.actions.onBlur.bind(this);
            }else{
                if (typeof jsonSchema.options.actions.onBlur === "object"){
                    let _self = this;
                    this.onBlur = (event) => {
                        executeSchema(_self, jsonSchema.options.actions.onBlur, event);
                    }
                    this.onBlur = this.onBlur.bind(this);
                }
            }
        }else{
            this.onBlur = this.default_onBlur.bind(this);
        }

        //Recorro los componentes xa setear los notifiers.
        for(var componentId in this.coreDefinition.components){

            if ((this.coreDefinition.components[componentId]) && (!this.coreDefinition.components[componentId].$$typeof) && (!coreTokenExists(this.coreDefinition.components[componentId], "props.jsonSchema.options.actions.notifyToParent"))){
                coreSetToken(this.coreDefinition.components[componentId], "props.jsonSchema.options.actions.notifyToParent", this.childNotification.bind(this));
            }
        }


        //Recorro los uiSchema y veo los q son fijos.
        for(var comp in this.coreDefinition.uiSchema){
            let _comp = this.coreDefinition.uiSchema[comp];
            let _compName = comp;
            if (_comp && !_comp.isTemplate && coreTokenExists(_comp, "props.urlSchema.url")){

                this.state.initializingUiSchema[comp] = true;
                let _self = this;
                let _callback = function (result){

                    var schema = JSON.parse(result.data.jsonData);
                    if (result.data.javascriptData !== undefined && result.data.javascriptData !== ""){
                      var actionFn = eval(result.data.javascriptData);
                      schema.props.jsonSchema.options.actions = {...schema.props.jsonSchema.options.actions, ...actionFn()};
                    }
        
                    if (schema.props.jsonSchema.data === undefined){
                      schema.props.jsonSchema.data = {};
                    }
        
                    if (_comp.props.urlSchema.props){
                        schema.props = coreJsonMerge(schema.props, _self.props.urlSchema.props);
                    }
        
                    if (!coreTokenExists(schema.props.jsonSchema.options,"id") && coreTokenExists(schema, "id")){
                        coreSetToken(schema,"props.jsonSchema.options.id", schema.id);
                    }
                    delete schema.id;
        
                    delete _comp.props.urlSchema;
                    if (_comp.props){
                        schema.props = coreJsonMerge(schema.props, _comp.props);
                    }

                    _self.coreDefinition.uiSchema[_compName] = schema;
                    let _state = { initializingUiSchema: {}};
                    _self.state.initializingUiSchema[_compName] = false;
                    _self.setState({});
                }
                console.log("Hago el request del esquema: " + _comp.props.urlSchema.url);
                httpRequest(null, _comp.props.urlSchema, _callback);
            }
        }

        //Agrego Listeners
        if (coreTokenExists(this.coreDefinition.jsonSchema.options, "decoration.listenResize") && this.coreDefinition.jsonSchema.options.decoration.listenResize){
            window.addEventListener('resize', this.updateContainerSize);
            //console.log("agrego el listener de resize en: " + this.coreDefinition.jsonSchema.options.id);
        }

        if (this.hasAction("initializeComponent")){
            newState.initialized = false;
            let _self = this;
            this.setState(newState, () => { _self.executeAction("initializeComponent"); _self.notifyParent("initialized", null, null);});
        }else{
            if (_setState){
                newState.initialized = true;
                this.setState(newState);
    
                // this.setState({initialized: true});
                this.notifyParent("initialized", null, null);
            }
        }

    }


    // defaultSuccessSubmit(){
    //     let _self = arguments[0];
    //     let _result = arguments[1];
    //     console.log("Success con: " + JSON.stringify(_result.response.data));
    // }

    // defaultErrorSubmit(){
    //     let _self = arguments[0];
    //     let _result = arguments[1];
    //     console.log("Error con: " + JSON.stringify(_result.response.data));
    // }

    // submit(){
    //     let _self = arguments[0];
    //     //Mando el data.
    //     let submitSchema = {};
    //     let jsonSchema = _self.props.jsonSchema;
    //     submitSchema.type = "POST";
    //     if (jsonSchema.options.type){
    //         submitSchema.type = jsonSchema.options.type;
    //     }else{
    //         if (jsonSchema.options.mode){
    //             switch (jsonSchema.options.mode){
    //                 case "INS":
    //                     submitSchema.type = "POST";
    //                     break;
    //                 case "UPD":
    //                     submitSchema.type = "PUT";
    //                     break;
    //                 case "DLT":
    //                     submitSchema.type = "DELETE";
    //                     break;
    //             }
    //         }
    //     }
    //     submitSchema.bodyData = {};
    //     submitSchema.bodyData.extraParams = jsonSchema.options.extraParams ?? {};
    //     submitSchema.bodyData.data = jsonSchema.data;

    //     submitSchema.url = jsonSchema.options.url ?? window.backendBaseUrl + jsonSchema.options.entity + '/' + submitSchema.type + 'Advanced';

    //     submitSchema.success = function(){
    //         let _self = arguments[0];
    //         _self.defaultSuccessSubmit.apply(null, arguments);
    //     }
    //     submitSchema.error = function(){
    //         let _self = arguments[0];
    //         _self.defaultErrorSubmit.apply(null, arguments);
    //     }

    //     httpRequest(_self, submitSchema);
    // }

    getOption(path){
        return coreSelectToken(this.coreDefinition, "jsonSchema.options." + path);
    }

    setOption(path, value){
        return coreSetToken(this.coreDefinition, "jsonSchema.options." + path, value);
    }

    onClick(event){
        let jsonSchema = this.coreDefinition.jsonSchema;
        if (coreTokenExists(jsonSchema, "options.actions.onClick")){
            if (typeof jsonSchema.options.actions.onClick === "function"){
                jsonSchema.options.actions.onClick.apply(this, [event]);
            }else{
                if (typeof jsonSchema.options.actions.onClick === "object"){
                    let _self = this;
                    executeSchema(this, jsonSchema.options.actions.onClick, event);
                }
            }
        }else{
            this.default_onClick.apply(this, [event]);
        }
    }

    onDoubleClick(event){
        let jsonSchema = this.coreDefinition.jsonSchema;
        if (coreTokenExists(jsonSchema, "options.actions.onDoubleClick")){
            if (typeof jsonSchema.options.actions.onClick === "function"){
                jsonSchema.options.actions.onDoubleClick.apply(this, [event]);
            }else{
                if (typeof jsonSchema.options.actions.onDoubleClick === "object"){
                    let _self = this;
                    executeSchema(this, jsonSchema.options.actions.onDoubleClick, event);
                }
            }
        }else{
            this.default_onDoubleClick(event);
        }
    }

    castToType(value){
        if (coreTokenExists(this.coreDefinition, "jsonSchema.schema")){
            let _dataType = this.coreDefinition.jsonSchema.schema.format ? this.coreDefinition.jsonSchema.format : this.coreDefinition.jsonSchema.schema.type;
            return castToType(_dataType, value, null);
        }else{
            return value;
        }
    }

    setData(){
        let _self = arguments[0];
        let _name = arguments[1];
        let _value = arguments[2] ?? null;
        let _setState = arguments[3] ?? true;
        let _dataSetted = false;

        _value = translateRelativePaths(_value, this, null);
        if (_name == null){
            if (_value && typeof _value === "object" && !Array.isArray(_value)){
                _self.state.data = {};
                _self.coreDefinition.jsonSchema.data = {};
                var _keys = Object.keys(_value);

                for(var _ind in _keys){
                    let _name = _keys[_ind];
                    if (coreTokenExists(this.coreDefinition.components, _name)){
                        _dataSetted = true;
                        let _dataType = this.coreDefinition.jsonSchema.schema.format ? this.coreDefinition.jsonSchema.format : this.coreDefinition.jsonSchema.schema.type;
                        let _formattedValue = _value[_keys[_ind]];
                        if (_dataType.substr(0,4) === "date"){
                            _formattedValue = castToType(_dataType, _value[_keys[_ind]], null);
                        }

                        _self.state.data[_keys[_ind]] = _formattedValue;
                        _self.coreDefinition.jsonSchema.data[_keys[_ind]] = _formattedValue;
                        if (_self.coreDefinition.components && _self.coreDefinition.components[_name] !== undefined){
                            coreSetToken(_self.coreDefinition.components[_keys[_ind]], "props.jsonSchema.data", _formattedValue);
                            coreSetToken(_self.coreDefinition.components[_keys[_ind]], "props.jsonSchema.options.initialState.data", _formattedValue);
                            //coreSetToken(_self.coreDefinition.components[_keys[_ind]], "props.jsonSchema.options.initialState.reason", "settedFromParent"+"_"+(new Date()).toISOString());
                        }
                    }
                }
                if (!_dataSetted){
                    //Me fijo sino es un panel...
                    if (coreTokenExists(this.coreDefinition.jsonSchema, "options.initialState.dataAsDataSource") && this.coreDefinition.jsonSchema.options.initialState.dataAsDataSource){
                        _self.state.data = _value;
                        _dataSetted = true;
                    }
                }
            }else{
                if ((!(_value === "" && coreSelectToken(_self.coreDefinition, "jsonSchema.schema.type") === "object")) || Array.isArray(_value)){
                    _self.state.data = _value;
                    _self.coreDefinition.jsonSchema.data = _self.state.data;
                    coreSetToken(_self.coreDefinition.jsonSchema, "options.initialState.data", _self.state.data);
                    _dataSetted = true;
                }
            }
        }else{
            if (coreTokenExists(_self.coreDefinition, 'jsonSchema.schema.properties.' + _name)){
                let _dataType = this.coreDefinition.jsonSchema.schema.properties[_name].format ? this.coreDefinition.jsonSchema.schema.properties[_name].format : this.coreDefinition.jsonSchema.schema.properties[_name].type;
                let _formattedValue = _value;
                if (_dataType.substr(0,4) === "date"){
                    _formattedValue = castToType(_dataType, _value, null);
                }else{
                    if (_dataType === "number" && !isNaN(parseFloat(_value))){
                        _formattedValue = parseFloat(_value);
                    }
                }

                if (_self.state.data === null || _self.state.data === undefined){
                    _self.state.data = {};
                }
                _self.state.data[_name] = _formattedValue;
                _self.coreDefinition.jsonSchema.data[_name] = _formattedValue;
                coreSetToken(_self.coreDefinition.components[_name], "props.jsonSchema.data", _formattedValue);
                coreSetToken(_self.coreDefinition.components[_name], "props.jsonSchema.options.initialState.data", _formattedValue);
                //coreSetToken(_self.coreDefinition.components[_name], "props.jsonSchema.options.initialState.reason", "settedFromParent"+"_"+(new Date()).toISOString());
                _dataSetted = true;
            }else{
                //Me fijo sino es un componente q tiene un esquema.
                if (_self.coreDefinition.jsonSchema.options.id === _name){
                    if (typeof _value === "string" && !isNaN(parseFloat(_value)) && _self.coreDefinition.jsonSchema.schema.type === "number" && _value.substr(-1) !== "."){
                        _self.state.data = parseFloat(_value);
                        _self.coreDefinition.jsonSchema.data = _self.state.data;
                    }else{
                        _self.state.data = _value;
                        _self.coreDefinition.jsonSchema.data = _value;
                    }
                    _dataSetted = true;
                }
            }
        }

        if (_setState && _dataSetted){
            if (typeof _value === "object"){
                _self.setState({
                    reason: "setted"+_name+"_"+(new Date()).toISOString()
                });    
            }else{
                _self.setState({
                    reason: "setted"+_name+"_"+_value
                });
            }
        }
    }

    childNotification(componentId, eventName, event, value){
        //console.log("Me notificaron a mí (" + this.coreDefinition.jsonSchema.options.id + "). El evento "+ eventName + " del componente: " + componentId + " con valor: " + value);

        let _action = componentId + '_' + eventName;
        let _specificEvent = "";
        if (event !== null && event.currentTarget !== null && event.currentTarget !== undefined && event.currentTarget.ariaLabel !== null && event.currentTarget.ariaLabel !== undefined){
            _specificEvent = _action + "_" + event.currentTarget.ariaLabel;
        }else{
            if (coreTokenExists(event, "target.parentElement.ariaLabel") && event.target.parentElement.ariaLabel !== null) {
                _specificEvent = _action + "_" + event.target.parentElement.ariaLabel;
            }            
        }

        if (coreTokenExists(this.coreDefinition.jsonSchema.options.actions, _action)){
            this.coreDefinition.jsonSchema.options.actions[_action].apply(this, [event, value]);
        }else if (coreTokenExists(this.coreDefinition.jsonSchema.options.actions, eventName)){
            this.coreDefinition.jsonSchema.options.actions[eventName].apply(this, [componentId, eventName, event, value]);
        }else if (_specificEvent !== "" && coreTokenExists(this.coreDefinition.jsonSchema.options.actions, _specificEvent)){
            this.coreDefinition.jsonSchema.options.actions[_specificEvent].apply(this, [event, value]);
        }else{
            switch(eventName){
                case "onChange":
                    this.setData(this, componentId, value, false);
                    //if (this.state.behaviour === "embeddedForm"){
                        this.notifyParent(eventName, event, this.state.data);
                    //}else{
//                        this.notifyParent(eventName, event, value);
//                    }
                    break;
                case "onBlur":
                    this.setData(this, componentId, value, false);
                    this.notifyParent(eventName, event, value);
                    break;
                case "initialized":
                    if (coreTokenExists(this.coreDefinition, "components."+componentId)){
                        this.setState((prevState) => {
                            let initializingComponent = prevState.initializingComponent;
                            initializingComponent[componentId] = false;
                            return ({
                                initializingComponent: initializingComponent
                            })
                        });

                    }else{
                        this.notifyParent(eventName, event, value);    
                    }
                    break;
                case "setDataSource":
                    console.log("childnotification.setdatasource");
                    if (coreTokenExists(this.coreDefinition, "jsonSchema.schema.properties." + componentId + ".type") && this.coreDefinition.jsonSchema.schema.properties[componentId].type === "object"){
                        this.setData(this, componentId, value, false);
                        this.notifyParent("onChange", event, this.state.data);
                    }
                    break;
                default:
                this.notifyParent(eventName, event, value);
                break;
            }
        }
    }
    notifyParent(eventName, event, value){
//        let _action = eventName + "_NotifyParent";
        //let _action = "notifyToParent";
        if (coreTokenExists(this.coreDefinition.jsonSchema.options.actions, "notifyToParent") && this.coreDefinition.jsonSchema.options.actions.notifyToParent !== null){
            let _shouldNotify = this.getOption("notifyToParent." + eventName);
            if (_shouldNotify !== false){
                //console.log("Soy " + this.coreDefinition.jsonSchema.options.id + ", y notifico a mi papi El evento "+ eventName + " con valor " + value);
                let _id = (coreTokenExists(this.coreDefinition.jsonSchema.options, "decoration.notifyId")) ? this.coreDefinition.jsonSchema.options.decoration.notifyId : this.coreDefinition.jsonSchema.options.id;
                this.coreDefinition.jsonSchema.options.actions.notifyToParent.apply(null, [_id, eventName, event, value]);
            }else{
                // console.log("Soy " + this.coreDefinition.jsonSchema.options.id + ", y no notifico a mi papi El evento "+ eventName + " porque está bloqueado");
            }
        }else{
            // console.log("Soy " + this.coreDefinition.jsonSchema.options.id + " y no tengo como notificar a mi papi");
        }
    }

    executeAction(){
        let _action = arguments[0];

        if (typeof this.coreDefinition.jsonSchema.options.actions[_action] === 'function'){
            let _arguments = [];
            for(let i = 1; i < arguments.length; i++){
                _arguments.push(arguments[i]);
            }
            return this.coreDefinition.jsonSchema.options.actions[_action].apply(this, _arguments);
        }else{
            let _functions = ["executeAction", "httpRequest", "setData", "setDataSource", "map", "concat"];
            if (typeof this.coreDefinition.jsonSchema.options.actions[_action] === 'object'){
                return executeSchema(this, this.coreDefinition.jsonSchema.options.actions[_action], arguments, null);
            }else{
                if (isFunction(this[_action])){
                    return this[_action].apply(null, arguments.slice(1));
                }
                console.log("no se cuenta con acción definida: " + _action);
            }
        }
    }

    async executeFunction(){
        let _function = arguments[0];
        let _arguments = [];

        switch (_function){
            case "httpRequest": 
                _arguments[0] = this;
                for(let i = 1; i < arguments.length; i++){
                    _arguments.push(arguments[i]);
                }
        
                try{
                    await httpRequest.apply(null, _arguments);
                }catch(ex){
                    if (ex.message !== "No se pudo armar la url"){
                        throw(ex);
                    }
                }

                break;
            case "clone": 
                return await clone(arguments[1]);
                break;
            case "InitializeMUIComponent": 
                return await InitializeMUIComponent(arguments[1], arguments[2], arguments[3]);
                break;
            case "coreSetToken": 
                return await coreSetToken(arguments[1], arguments[2], arguments[3]);
                break;
            case "castToType": 
                return await castToType(arguments[1], arguments[2], arguments[3]);
                break;
            case "coreSelectToken": 
                return await coreSetToken(arguments[1], arguments[2]);
                break;
            case "parseSchema": 
                return await parseSchema(arguments[1], arguments[2], arguments[3]);
                break;
            case "deleteComponentFromCache": 
                deleteComponentFromCache(arguments[1]);
                break;
            default: 
                console.error("No se que hacer con la función: " + _function);
        }
    }

    httpRequestSync(requestSchema){
        return httpRequestSync(this, requestSchema);
    }

    hasAction(actionName){
        return (coreTokenExists(this.coreDefinition.jsonSchema.options.actions, actionName) && this.coreDefinition.jsonSchema.options.actions[actionName] !== null);
    }

    default_onClick(event){
        let _eventClicked = event.currentTarget.ariaLabel;
        let _specificClick = "onClick_" + _eventClicked;
        if (typeof this[_specificClick] === "function"){
            this[_specificClick](event);
        }else{
            this.notifyParent("onClick", event);
        }
    }

    default_onChange(event){

        let _value = null;
        let _name = this.coreDefinition.jsonSchema.options.id;

        if (event !== null){
            if (event._isAMomentObject){
                // _name = this.coreDefinition.jsonSchema.options.id;
                if (event.isValid()){
                    _value = event.toISOString();
                }else{
                    _value = event;
                }
            }else{
                _name = event.target.name;
    
                if (event.target.type === "checkbox"){
                    _value = event.target.checked;
                }else{
                    if (event.target.type === "file"){
                        // _name = this.coreDefinition.jsonSchema.options.id;
                        _value = event.target.files[0];
                    }else{
                        _value = event.target.value;
                        if ((typeof _value === "string") && _value !== "" && this.coreDefinition.jsonSchema.schema.type === "number"){
                            this.state.error = false;
                            if (isNaN(parseFloat(_value*1))){
                                //si termina con punto podría dejarlo pasar.. para eso me fijo si le agrego un cero y se arregla..                                
                                if (_value.substr(-1) === "."){
                                    let _check = _value + "0";
                                    if (isNaN(parseFloat(_check*1)) || parseFloat(_check*1).toString() !== _value.substring(0, _value.length-1)){
                                        _value = this.state.data;
                                        //this.state.error = true;
                                    }
                                }else{
                                    _value = this.state.data;
                                }
                            }
                        }
                    }
                }
            }
        }
        
        //console.log('Entre a default_onchange de ' + this.coreDefinition.jsonSchema.options.id + ' value: ' + _value);

        this.setData(this, _name, _value, true);
        if (!coreTokenExists(this.coreDefinition.jsonSchema,"options.notifyToParent") || this.coreDefinition.jsonSchema.options.notifyToParent.onChange){
            this.debounce(() => {this.notifyParent("onChange", event, _value)}, this.state.onChangeDebounce);
        }
    }

    debounce = (func, delay) => {
        clearTimeout(this.onChangeTimeout);
        this.onChangeTimeout = setTimeout(() => {
            func.apply(this);
        }, delay);
    };

    default_onDoubleClick(event){

        let _name = event.target.name;
        let _value;

        
        if (event._isAMomentObject){
            _value = event.toISOString();
        }else{
            if (event.target.type === "checkbox"){
                _value = event.target.checked;
            }else{
                _value = event.target.value;
            }
        }
        
        console.log('Entre a default_onDoubleClick de ' + this.coreDefinition.jsonSchema.options.id + ' value: ' + _value);

        if (!coreTokenExists(this.coreDefinition.jsonSchema,"options.notifyToParent") || this.coreDefinition.jsonSchema.options.notifyToParent.onDoubleClick){
            this.notifyParent("onDoubleClick", event, _value);
        }
    }

    default_onBlur(event){
        let _value;

        if (event._isAMomentObject){
            _value = event.toISOString();
        }else{
            if (event.target.type === "checkbox"){
                _value = event.target.checked;
            }else{
                _value = event.target.value;
            }
        }


        if (!coreTokenExists(this.coreDefinition.jsonSchema,"options.notifyToParent") || this.coreDefinition.jsonSchema.options.notifyToParent.onBlur){
            this.notifyParent("onBlur", event, _value);
        }
        console.log('Entre a onBlur de ' + this.coreDefinition.jsonSchema.options.id + ' value: ' + _value);
    }

    onChange(event){
        console.log("Entro a onchange x defecto");
        this.default_onChange(event);
    }

    onBlur(){

    }

    onContextMenu(e){
        e.preventDefault();
        if (this.hasAction("onContextMenu")){
            this.executeAction("onContextMenu", e);
        }        
    }
    async setDataSource(_data, _totalRows, _page, _size, _setState){
        let jsonSchema = this.coreDefinition.jsonSchema;
        if (this.state.dataSourceAction === "replace"){
            jsonSchema.options.dataSource = _data;
        }else{
            jsonSchema.options.dataSource = [...jsonSchema.options.dataSource, ..._data];
        }
        if (_setState !== false){
            if (this.state.dataSourceAction === "add" && this.state.actualPage < _page){
                //Es un fetchmore.. así que no cambio los rows to display
                this.setState({
                    lastPage: Math.floor(jsonSchema.options.dataSource.length / (this.state.rowsPerPage ?? 1)),
                    totalRows: _totalRows ?? jsonSchema.options.dataSource.length,
                    loading: false,
                    reason: "setDataSource_" + (new Date()).toISOString()
                });
            }else{
                if (typeof this.setRowsToDisplay === "function"){
                    //o hice un refresh o se actualizó la misma página x un fetch.
                    //Si actualPage != _page entonces estoy cacheando datos nomas...
                    let _updateState = ((this.state.dataSourceAction === "replace") || (this.state.actualPage === _page));
                    await this.setRowsToDisplay(_page ?? this.state.actualPage, _updateState);
                }
                this.setState({
                    selected: (this.state.dataSourceAction === "replace") ? [] : this.state.selected,
                    actualPage: (this.state.dataSourceAction === "replace") ? 1 : this.state.actualPage,
                    currentRow: (this.state.dataSourceAction === "replace") ? -1 : this.state.currentRow,
                    lastPage: Math.floor(jsonSchema.options.dataSource.length / (this.state.rowsPerPage ?? 1)),
                    totalRows: _totalRows ?? _data.length,
                    loading: false,
                    reason: "setDataSource_" + (new Date()).toISOString()
                });
            }
            
        }
        this.notifyParent("setDataSource", null, jsonSchema.options.dataSource);
        if (jsonSchema.options.emptySelectFirst !== undefined){
            //Es un componente select y no un panel.
            let _actualValue = this.state.data;
            let _existe = false;
            for(let _row of jsonSchema.options.dataSource){
                if (_row.value === _actualValue){
                    _existe = true;
                    break;
                }
            }
            //_actualValue = (_existe || jsonSchema.options.dataSource.length === 0) ? this.state.data : null;
    
            if (!_existe && jsonSchema.options.emptySelectFirst && jsonSchema.options.dataSource.length > 0 
                && (_actualValue === null || _actualValue === undefined || _actualValue === "")){
                _actualValue = jsonSchema.options.dataSource[0].value;         
            }
            if (_actualValue !== this.state.data){
                this.setData(this, null, _actualValue);
                this.notifyParent("onChange", null, _actualValue);
            }    
        }

    }

    // modalOpen(){
    //     this.props.jsonSchema.options.modalContentSchema.props.jsonSchema.options.mode = "PROMPT";
    // }

    modalCallback(){
        let _data = arguments[0];
        this.setData(this, null, _data, true);
    }

    async renderUiSchema(layout, jsonSchema, _input){
        //Si ya es un jsonSchemae React... no hago nada.
        let _currentBreakpoint = this.getCurrentBreakpoint();
        if (this.state.decoration.currentBreakpoint !== _currentBreakpoint){
            if (layout.$$typeof !== undefined){
                layout.$$typeof = undefined;
            }        
            this.setState((prevState) => ({
                ...prevState,
                decoration: {
                    ...prevState.decoration,
                    currentBreakpoint: _currentBreakpoint
                },
                reason: "breakPointChanged_"+(new Date().toISOString())
            }));
            return;
        }

        // if (coreTokenExists(this.coreDefinition, "jsonSchema.options.initialState.renderType") && this.coreDefinition.jsonSchema.options.initialState.renderType === "auto"){
        //     let _renderType = window.matchMedia("(max-width: 500px)").matches ? "grid": "table";
        //     if (this.state.renderType !== _renderType){
        //         if (layout.$$typeof !== undefined){
        //             layout.$$typeof = undefined;
        //         }        
        //         this.setState({
        //             renderType: _renderType,
        //             reason: "wideChanged_"+(new Date().toISOString())
        //         });
        //     }
        // }

        if (layout.$$typeof !== undefined){
            this.setState({
                rendering: false,
                rendered: true
            });
            this.Content = layout;
            return;
        }

        
        let _renderTimeStamp = new Date().toISOString();
        this.setOption("renderTimeStamp", _renderTimeStamp);
        let _layout = await clone(layout);

        parseSchema(this, _layout, _input)
            .then((_rendered) => {
                if (this.getOption("renderTimeStamp") === _renderTimeStamp){
                    this.Content = _rendered;
                    this.setState({
                        rendering: false,
                        rendered: true
                    });
                    // if (this.myRef.current) {
                    //     // El ref ha sido establecido, haz algo con él
                    //     console.log(this.myRef.current.offsetWidth);
                    //   }
              
                }else{
                    console.log("no doy bola a este resultado porque mandaron uno más nuevo. A mi " + this.coreDefinition.jsonSchema.options.id + " me ejecutaron: " + _renderTimeStamp + " y el último es: " + this.getOption("renderTimeStamp"));
                }
            })
            .catch((response) => {
                if (this.getOption("renderTimeStamp") === _renderTimeStamp){
                    this.setState({
                        rendering: false,
                        rendered: false
                    });                    
                    console.error("tengo error al renderizar el componente: " + this.coreDefinition.jsonSchema.options.id + " con error: " + response);
                }else{
                    console.log("no doy bola a este catch porque mandaron uno más nuevo. A mi " + this.coreDefinition.jsonSchema.options.id + " me ejecutaron: " + _renderTimeStamp + " y el último es: " + this.getOption("renderTimeStamp"));
                }
                
            });

        this.setState({
            rendering: true,
            rendered: false,
        });
    
        //return (_rendered);
    }

    render() {
        // if (!this.state.initialized && coreJsonIsEmpty(this.state.initializingComponent)){
        //     return <></>;
        // }
        
        return (this.Content);

        // //Parche hasta manejar bien state y props
        // if (!this.coreDefinition.jsonSchema.options.componentInitialized){
        //     console.log("invoco a initalizaComponent de " + this.coreDefinition.jsonSchema.options.id + " desde render")
        //     this.initializeComponent(true);
        // }
 
        // let layout = this.coreDefinition.uiSchema['layout'];
        // if (layout && !coreJsonIsEmpty(layout)){
        //     let _return = this.renderUiSchema(layout, this.coreDefinition.jsonSchema, null);
        //     return _return;
        // }else{
        //     layout = this.coreDefinition.uiSchema['ui:layout'];
        //     if (layout && !coreJsonIsEmpty(layout)){
        //         return this.renderUiSchema(layout, this.coreDefinition.jsonSchema, null);
        //     }else{
        //         return <></>;
        //     }
        // }
    }

    getCurrentBreakpoint(){
        //Si tengo definido breakpoints relativos uso los relativos.
        //Si tengo datos del conteneder (padre), uso los datos relativos al padre, sino uso los datos de la pantalla.
        let _currentBreakpoint = "";
        let widthReference = window.innerWidth || document.documentElement.clientWidth;
        
        if (this.state.decoration.useRelativeBreakpoint){
            if (this.myRef !== null && this.myRef.current !== null){
                widthReference = this.myRef.current.clientWidth;
            }else{
                if (coreTokenExists(this.coreDefinition, "jsonSchema.options.decoration.parentRef") && this.coreDefinition.jsonSchema.options.decoration.parentRef !== null && this.coreDefinition.jsonSchema.options.decoration.parentRef !== undefined){
                    widthReference = this.coreDefinition.jsonSchema.options.decoration.parentRef.clientWidth;
                }
            }
        }
        // if (coreTokenExists(this.coreDefinition, "jsonSchema.options.decoration.relativeBreakpoints")){
        //     breakpoints = this.coreDefinition.jsonSchema.options.decoration.relativeBreakpoints;
        // }

        if (coreTokenExists(this.coreDefinition.jsonSchema.options, "decoration.breakpoints")){
            let _breakpoints = [];            
            for(let breakpoint in this.coreDefinition.jsonSchema.options.decoration.breakpoints){
                if (isNaN(this.coreDefinition.jsonSchema.options.decoration.breakpoints[breakpoint]*1)){
                    _breakpoints.push(this.coreDefinition.jsonSchema.options.decoration.breakpoints[breakpoint].replace("px", "")*1);
                }else{
                    _breakpoints.push(this.coreDefinition.jsonSchema.options.decoration.breakpoints[breakpoint]*1);
                }
            }
            let _breakpoint = _breakpoints.sort((a,b) => {return (b - a)}).filter(x => {return x <= widthReference})[0];
            let _breakpointToReturn = '';
            for(let breakpoint in this.coreDefinition.jsonSchema.options.decoration.breakpoints){
                if (isNaN(this.coreDefinition.jsonSchema.options.decoration.breakpoints[breakpoint]*1)){
                    if (this.coreDefinition.jsonSchema.options.decoration.breakpoints[breakpoint] === _breakpoint+"px"){
                        _breakpointToReturn = breakpoint;
                        break;
                    }
                }else{
                    if (this.coreDefinition.jsonSchema.options.decoration.breakpoints[breakpoint]*1 === _breakpoint){
                        _breakpointToReturn = breakpoint;
                        break;
                    }
                }
            }

            return _breakpointToReturn;
        }

        return _currentBreakpoint;
    }

    setCurrentBreakpoint(_currentBreakpoint){
        let _renderAs = this.state.decoration.renderAs;
        if (coreTokenExists(this.coreDefinition.jsonSchema.options, "decoration.layoutBreakpoints")){
            if (this.coreDefinition.jsonSchema.options.decoration.layoutBreakpoints[_currentBreakpoint] !== undefined){
                _renderAs = this.coreDefinition.jsonSchema.options.decoration.layoutBreakpoints[_currentBreakpoint];
            }else if (this.coreDefinition.jsonSchema.options.decoration.layoutBreakpoints.default !== undefined){
                _renderAs = this.coreDefinition.jsonSchema.options.decoration.layoutBreakpoints.default;
            }
        }

        this.setState((prevState) => ({
            ...prevState,
            decoration: {
                ...prevState.decoration,
                currentBreakpoint: _currentBreakpoint,
                renderAs: _renderAs
            }
        }));
    }

    async updateContainerSize() {
        const containerElement = this.myRef.current;
        let _width = window.innerWidth || document.documentElement.clientWidth;
        let _height = window.innerHeight || document.documentElement.clientHeight;
        let _offsetWidth = window._offsetWidth || document.documentElement.offsetWidth;
        let _offsetHeight = window._offsetHeight || document.documentElement.offsetHeight;
        //console.log("updatecontainersize de: " + this.coreDefinition.jsonSchema.options.id);
        //if (this.state.decoration.offsetWidth == 0){
        // if (coreTokenExists(this.coreDefinition.jsonSchema.options, "decoration.listenResize") && this.coreDefinition.jsonSchema.options.decoration.listenResize){
        //     window.addEventListener('resize', this.updateContainerSize);
        //     console.log("agrego el listener de resize en: " + this.coreDefinition.jsonSchema.options.id);
        // }

        if (containerElement && typeof containerElement.getBoundingClientRect === "function") {
            _width  = containerElement.getBoundingClientRect().width;
            _height = containerElement.getBoundingClientRect().height;
            _offsetWidth = containerElement.offsetWidth;
            _offsetHeight = containerElement.offsetHeight;
        }
        
        let _renderAs;
        let _currentBreakpoint = this.getCurrentBreakpoint();

        if (this.state.decoration.offsetWidth !== _offsetWidth){
            let _thenFunction = (this.hasAction("updateContainerSizeCustom")) ? this.updateContainerSizeCustom : null;
            //if (_thenFunction === null){

                if (this.state.view !== null && this.state.view !== undefined){
                    if (coreTokenExists(this.coreDefinition.jsonSchema, "options.views." + this.state.view + ".state.decoration.renderAs")){
                        _renderAs = this.coreDefinition.jsonSchema.options.views[this.state.view].state.decoration.renderAs;
                        if (_renderAs === "auto"){
                            if (coreTokenExists(this.coreDefinition.jsonSchema.options, "decoration.layoutBreakpoints")){
                                if (coreTokenExists(this.coreDefinition.jsonSchema.options.decoration.layoutBreakpoints, _currentBreakpoint)){
                                    _renderAs = this.coreDefinition.jsonSchema.options.decoration.layoutBreakpoints[_currentBreakpoint];
                                }else{
                                    _renderAs = this.coreDefinition.jsonSchema.options.decoration.layoutBreakpoints.default;
                                }
                            }
                        }
                    }
                }else{
                    if (coreTokenExists(this.coreDefinition.jsonSchema, "options.initialState.decoration.renderAs")){
                        _renderAs = this.coreDefinition.jsonSchema.options.initialState.decoration.renderAs;
                        if (_renderAs === "auto"){
                            if (coreTokenExists(this.coreDefinition.jsonSchema.options, "decoration.layoutBreakpoints")){
                                if (coreTokenExists(this.coreDefinition.jsonSchema.options.decoration.layoutBreakpoints, _currentBreakpoint)){
                                    _renderAs = this.coreDefinition.jsonSchema.options.decoration.layoutBreakpoints[_currentBreakpoint];
                                }else{
                                    _renderAs = this.coreDefinition.jsonSchema.options.decoration.layoutBreakpoints.default;
                                }
                            }
                        }
                    }
                }
                
                if (_renderAs === null || _renderAs === undefined){
                    _renderAs = _currentBreakpoint === "xs" ? "mobile" : "web";
                }        
            //}

            this.setState((prevState) => ({
                ...prevState,
                decoration: {
                    ...prevState.decoration,
                    containerWidth: _width,
                    containerHeight: _height,
                    offsetWidth: _offsetWidth,
                    offsetHeight: _offsetHeight,
                    renderAs: _renderAs,
                    currentBreakpoint: _currentBreakpoint
                }
            }), _thenFunction);
        }
    }

    componentDidMount(){
        // console.log("Se monta el componente: " + this.coreDefinition.jsonSchema.options.id);
        
        if (coreTokenExists(this.props, "urlSchema.url") && this.props.urlSchema.url !== ""){
            this.loadSchema();
        }else{            
            this.core_InitializeComponent(true);
        }

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateContainerSize);
    }
    
    componentDidUpdate(){
        //console.log("componente didupdate: " + this.coreDefinition.jsonSchema.options.id + " myRef: " + this.myRef.current);
        

        if (coreSelectToken(this.coreDefinition.jsonSchema.options, "decoration.updateOnResize") !== false){
            this.updateContainerSize();            
        }
        
        if (this.myRef.current && this.state.currentPosition !== -1 && this.myRef.current.type === "text" && this.myRef.current.setSelectionRange !== undefined) {
            //this.myRef.current.focus();
            this.myRef.current.setSelectionRange(this.state.currentPosition, this.state.currentPosition); // Establece la posición del cursor a partir del índice 3
        }
    
    }


    onKeyDown = async (event) => {
        if (event.keyCode === 8) {
            // Lógica a ejecutar cuando se presione la tecla "Backspace"
            this.state.currentPosition = event.target.selectionStart > 0 ? event.target.selectionStart - 1 : 0;
        }else{
            if ((event.key === 'v' || event.key === 'V') && event.ctrlKey) {
                // Lógica a ejecutar cuando se presione "Ctrl + V"
                const clipboardText = await navigator.clipboard.readText();
                const clipboardLength = clipboardText.length;
                //this.state.currentPosition = event.target.selectionStart + clipboardLength;
                this.setState({currentPosition: (event.target.selectionStart + clipboardLength)});
            }else{
                if (event.keyCode === 46){
                    //Si es Supr
                    this.state.currentPosition = event.target.selectionStart;
                }else{
                    this.state.currentPosition = event.target.selectionStart + 1;
                }
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        //console.log("Entré al Should Component update de Core con id: " + this.coreDefinition.jsonSchema.options.id);
        // if (this.coreDefinition.jsonSchema.options.id === "panel_registro"){
        //     console.log("estoy en form_entidad");
        // }

        if (JSON.stringify(nextProps) != JSON.stringify(this.previousProps)){
            this.mergeWithProps(nextProps);
            if ((typeof this.setRowsToDisplay === "function") && this.state.dataAsDataSource){
                this.refresh();
            }
            console.log("Actualizo las propiedades porque son distintas.: " + this.coreDefinition.jsonSchema.options.id);
            return false;
        }

        if (!this.state.initialized && nextState.initialized && nextState.initializeData && this.hasAction("loadDataSource") && (this.state.view === "default" || this.state.view === undefined)
            && (this.state.behaviour !== "subEntity" || (this.state.behaviour === "subEntity" && coreTokenExists(this.coreDefinition, "jsonSchema.options.dataSource") 
            &&  this.coreDefinition.jsonSchema.options.dataSource &&  this.coreDefinition.jsonSchema.options.dataSource.length === 0))){
            this.setState({loading: true, initializeData: false});
            console.log("Entré al Should Component update de Core con id: " + this.coreDefinition.jsonSchema.options.id + " y hago el loadDataSource");
            this.executeAction("loadDataSource");
            return true;
        }

        if (this.state.rendering && !nextState.rendering && nextState.rendered){
            //Es un aviso que terminó de renderizar
            return true;
        }else if (this.state.rendering && !nextState.rendering && !nextState.rendered){
            //Es un aviso de que terminó de renderizar ... xo hubo error entonces no anduvo.
            //Acá habría q desplegar algo...
            return true;
        }else if (!this.state.rendering && nextState.rendering && !nextState.rendered){
            //Es un aviso que empezó a renderizar.
            //Acá se debería de mostrar un loading...
            return true;
        }else if (this.state.rendering && !nextState.rendering){
            //Si está renderizando y el nuevo setState no es xa avisar que terminó... hago un reRender
            this.renderUiSchema(this.coreDefinition.uiSchema.layout, this.coreDefinition.jsonSchema, null);
            return false;
        }else if (!this.state.rendered && nextState.rendered){
            //Se renderizó.
            return true;
        }else
        {
            //Si cambio algo entre los estados.
            if (nextState.initialized && JSON.stringify(this.state) !== JSON.stringify(nextState)){
                this.renderUiSchema(this.coreDefinition.uiSchema.layout, this.coreDefinition.jsonSchema, null);
                return false;
            }else{
                if (coreTokenExists(nextProps, "jsonSchema.data") && coreTokenExists(this.props, "jsonSchema.data") && nextProps.jsonSchema.data !== undefined && JSON.stringify(this.props.jsonSchema.data) !== JSON.stringify(nextProps.jsonSchema.data)){
                    this.setState({rendered: false, initialized: false, initializeData: true});                    
                    return false;
                }else{
                    return true;
                }
            }
        }

        return true;
    }

    // UNSAFE_componentWillReceiveProps(nextProps){
    //     console.log("Entré al UNSAFE_componentWillReceiveProps de Core con id: " + this.coreDefinition.jsonSchema.options.id);
    //     if (this.coreDefinition.jsonSchema.options.id === "form_entidad"){
    //         console.log("estoy en form_entidad");
    //     }
    //     if (JSON.stringify(this.props.jsonSchema) !== JSON.stringify(nextProps.jsonSchema)){
    //         this.mergeWithProps(nextProps);
    //         if (nextProps.jsonSchema.options.initialState && (JSON.stringify(this.props.jsonSchema.options.initialState) !== JSON.stringify(nextProps.jsonSchema.options.initialState))){
    //             //Reseteo los estados...
    //             let newState = coreJsonMerge(this.state, nextProps.jsonSchema.options.initialState);
    //             this.setState(newState);
    //             console.log("Reseteo el estado porque no coincinde con el original.");
    //         }
    //         console.log("Actualizo las propiedades porque son distintas.: ");
    //         return true;
    //     }else{
    //         //Lo mando en true xq pueden haber cambiado los children
    //         if (nextProps.children){
    //             this.setState({reason: "newProps_" + (new Date()).toISOString()});
    //             return true;
    //         }else{
    //             return false;
    //         }
    //     }
    //     // if (coreTokenExists(this.props, "jsonSchema.options")){
    //     //     let _newOptions = clone(nextProps.jsonSchema.options);
    //     //     let _actualOptions = clone(this.props.jsonSchema.options);
    //     //     delete _newOptions.actions;
    //     //     delete _actualOptions.actions;
    //     //     if (JSON.stringify(_actualOptions) === JSON.stringify(_newOptions)){
    //     //         console.log("No actualizo el componente porque los options no cambiaron");
    //     //         return false;
    //     //     }
    //     // }else{
    //     //     return 
    //     //     console.log("newProps: " + JSON.stringify(nextProps));
    //     // }

    //     return true;
    // }

    opa(msg){
        alert(msg);
    }
    setCoreDefinition(jsonData){
        this.coreDefinition = jsonData;
    }

    getFingerPrint(){
        // Obtener el fingerprint
        const fingerprint = this.client.getFingerprint();
        console.log('Fingerprint del navegador:', fingerprint);
        return fingerprint;
    }
}

export default CoreComponent;